export default "__VITE_ASSET__Bm$vg6lc__"